module.exports = __webpack_public_path__ + "static/media/basic-comment.603b4da2.png";